import appConfig from '@nerdwallet/app-config';
import { HOMEPAGE as analyticsBase } from '../analytics-constants';

export default {
  title: "Our Nerds' top products",
  titleEnd: 'for 2023',
  subtitle: `Narrow down your financial options and get ready for your smartest year yet with our nerdy list of the year's best credit cards, bank accounts, and more.`,
  backgroundColor: '#00682C',
  backgroundColorMobile: '#8DF100',
  ctaButtonText: 'shop the list',
  ctaLinkUrl: '/l/awards',
  titlePreColor: '#8df100',
  titleEndColor: '#e2ff39',
  visualBackgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/best-of-awards-2023-hp-campaign.png`,
  visualBackgroundImageAlt: 'NerdWallet Best-Of Awards 2023',
  elementImpressionEntityName: analyticsBase.entity_names.campaign, // used for the Impression of the component
  elementImpressionSectionName: analyticsBase.section_name,
  trkQueryParam: analyticsBase.entity_names.campaign, // used to append to the URL when the button is clicked
};
